import { render, staticRenderFns } from "./twoFactor.vue?vue&type=template&id=10c5d4a8&scoped=true"
import script from "./twoFactor.vue?vue&type=script&lang=js"
export * from "./twoFactor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5d4a8",
  null
  
)

export default component.exports